import { connect } from 'react-redux';

import { closeOverlay } from 'app/shared/modules/overlay/actions';
import { logout } from 'app/dealer/login/actions';
import { openNavMenuClick } from 'app/dealer/actions';
import { setHasCookieConsent } from 'app/dealer/cookieDashboard/actions';

import { TopNavBar } from './TopNavBar';

const mapStateToProps = (state) => {
  const { dealerLogin, cookieDashboard } = state;
  return {
    authorities: dealerLogin.authorities,
    dealerLoggedIn: dealerLogin.userLoggedIn,
    hasSavedCookieSettings: cookieDashboard.hasSavedCookieSettings,
  };
};

export const ConnectedTopNavBar = connect(mapStateToProps, {
  setHasCookieConsent,
  closeOverlay,
  logout,
  openNavMenuClick,
})(TopNavBar);
